import { format } from 'date-fns'
import { Calendar as CalendarIcon } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Calendar } from '@/components/ui/calendar'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import type { FieldError } from 'react-hook-form'
import { InputErrorText } from '@/components/input-error-text'
import clsx from 'clsx'

interface DatePickerProps {
  date: Date | undefined
  setDate: (date: Date | undefined) => void
  error?: FieldError
}

export function DatePicker({ date, setDate, error }: DatePickerProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          data-empty={!date}
          className={clsx(
            'data-[empty=true]:text-muted-foreground w-full justify-start text-left font-normal',
            { 'border-destructive': !!error },
          )}
          size={'lg'}
        >
          <CalendarIcon />
          {date ? format(date, 'dd/MM/yyyy') : <span>Selecione a data</span>}
        </Button>
      </PopoverTrigger>
      <InputErrorText error={error} />
      <PopoverContent className="w-auto p-0">
        <Calendar mode="single" selected={date} onSelect={setDate} />
      </PopoverContent>
    </Popover>
  )
}
